<script lang="ts" setup>
import { ref } from 'vue'
import type { ChapterConfig } from '../configs/types'
import { getChapterConfig } from '../configs/brands'
import { POP_TYPE } from '@/constants'
import { resources } from '@/config/brands'

defineProps<{
  value: boolean
  discountPayInfo: Record<string, any>
}>()

const emit = defineEmits<{
  (e: 'close'): void
  (e: 'input', value: boolean): void
}>()

// 加载当前品牌的 chapter 配置
const config: ChapterConfig = getChapterConfig()

const countdownTime = ref<number>(3)
const timer = setInterval(() => {
  countdownTime.value--
  if (countdownTime.value < 0) {
    clearInterval(timer)
    handleClose()
  }
}, 1000)

// 从配置中获取颜色
const coinsGradient = config.colors.coinsGradient
const coinsPopupText1 = config.colors.coinsPopupText1
const coinsPopupText2 = config.colors.coinsPopupText2
const coinsPopupText3 = config.colors.coinsPopupText3
const coinsPopupText4 = config.colors.coinsPopupText4

function handleClose() {
  emit('close')
  emit('input', false)
}
</script>

<template>
  <BasicPopup :value="value" :pop-type="POP_TYPE.CENTER" @input="value => $emit('input', value)">
    <div v-if="value" class="w-266px min-h-237px rounded-12px basic-coins-sucess pt-22px pb-20px px-20px">
      <div class="coins-text-1 text-20px flex justify-center mb-16px">
        {{ config.texts.coinsSuccessTitle }}
      </div>
      <div class="w-full h-70px flex items-center">
        <div class="coins-lef-bg w-110px h-70px flex items-center px-20px ">
          <img class="w-20px h-20px" :src="resources.coin" alt="">
          <span class="coins-text-2 ml-4px text-20px font-bold">{{ discountPayInfo.discountOnceCoins }}</span>
        </div>
        <img class="w-20px h-20px absolute left-123px" src="@/assets/coins-center.png" alt="">
        <div class="coins-right-bg w-110px h-70px flex items-center justify-center px-20px  ml-10px">
          <img class="w-32px h-42px rounded-4px" :src="discountPayInfo.bookImageUrl" alt="">
        </div>
      </div>
      <div class="text-12px coins-text-3 leading-16px break-all flex justify-center mt-12px">
        {{ config.texts.coinsSuccessDesc1 }}
      </div>
      <div class="text-12px coins-text-3 leading-16px break-all flex justify-center8">
        {{ config.texts.coinsSuccessDesc2 }}
      </div>
      <div class="flex items-center justify-center cursor-pointer mt-20px">
        <div class="coins-text-4 w-127px py-10px px-19px btn-solid flex justify-center text-14px rounded-20px inline-block box-border" @click="handleClose">
          {{ config.texts.coinsSuccessButton }} <span v-if="countdownTime">({{ countdownTime }}s)</span>
        </div>
      </div>
    </div>
  </BasicPopup>
</template>

<style lang="scss" scoped>
.basic-coins-sucess {
  background-image: v-bind(coinsGradient);
}
// 标题
.coins-text-1 {
  color: v-bind(coinsPopupText1) !important;
}
// 金额
.coins-text-2 {
  color: v-bind(coinsPopupText2) !important;
}
// 描述
.coins-text-3 {
  color: v-bind(coinsPopupText3)!important;
}
// ok按钮文字
.coins-text-4 {
  color: v-bind(coinsPopupText4)!important;
}

.coins-lef-bg {
  background: url('@/assets/coins-left.png') no-repeat;
  background-size: 100% 100%;
}

.coins-right-bg {
  background: url('@/assets/coins-right.png') no-repeat;
  background-size: 100% 100%;
}
</style>
